// eslint-disable-next-line
import React from 'react';
import { Tag } from 'antd';
import { useSelector } from 'react-redux';
import { AppState } from 'appRedux/reducers/ReducerState';
import styled, { keyframes } from 'styled-components';
import dayjs from 'dayjs';
import { CalendarOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import cn from '@/utils/cn';

export const SystemDateTag: React.FC = () => {
  const systemConfig = useSelector((state: AppState) => state.systemConfig);
  const { dataSource: dataSourceConfig } = systemConfig;
  const SYSTEM_DATE = dataSourceConfig?.SYSTEM?.SYSTEM_DATE;

  const isPastDate = dayjs(SYSTEM_DATE).isBefore(dayjs(), 'day');

  return (
    <div className={cn(
      'inline-flex items-center justify-center gap-1.5 py-[6px] px-[12px] rounded-full font-[600] text-sm cursor-default border shadow-sm select-none',
      isPastDate
        ? 'bg-red-100 border-red-300 text-red-500'
        : 'bg-[#e6f7ff] border-[#91d5ff] text-[#1890ff]',
    )}>
      <span
        className={cn(
          'hidden md:inline-flex items-center justify-center size-[18px] shrink-0 rounded-full text-white shadow-[0_1px_3px_rgba(0,0,0,0.2)]',
          isPastDate
            ? 'bg-gradient-to-br from-[#ff4d4f] to-[#ff7875] border border-[#cf1322]'
            : 'bg-gradient-to-br from-[#1677ff] to-[#4096ff] border border-[#0958d9]',
        )}
      >
        <FontAwesomeIcon icon={faCalendar} className='text-[9px] leading-none mb-[1px]' />
      </span>
      <span className='whitespace-nowrap leading-none tabular-nums'>
        {dayjs(SYSTEM_DATE).format('DD/MM/YYYY')}
      </span>
    </div>
  );
};

export default SystemDateTag;
